import { useNavigate } from "@remix-run/react";
import { ArrowRight } from "lucide-react";
import { Button } from "~/components/ui/button";

export default function HeroSection() {
  const navigate = useNavigate();

  return (
    <section className="dot-background pt-16 shadow-[inset_4px_4px_300px_100px_#ecfdf5]">
      <div className="container relative flex flex-col items-center gap-20 md:gap-8">
        <div className="flex max-w-2xl flex-col items-center gap-8 pt-16 md:pb-12 md:pt-20">
          <div className="flex animate-fade-in-down flex-col gap-2 text-center">
            <h1 className="font-recursive text-4xl font-bold !leading-tight tracking-tight sm:text-5xl md:text-6xl">
              The best of{" "}
              <span className="rounded-sm bg-emerald-500 px-2 py-1 text-white">
                Excel,
              </span>{" "}
              now in your Knack app
            </h1>
            <p className="font-recursive text-base md:text-xl">
              KnackSheet gives your users the Excel features they love, right in
              your Knack app - all without writing your own code.
            </p>
          </div>
          <Button
            className="h-fit animate-fade-in-down px-8 py-3 text-lg font-semibold leading-normal"
            onClick={() => navigate("/login?try")}
          >
            Try free for 14 days <ArrowRight className="ml-1 h-6 w-6" />
          </Button>
        </div>

        <video
          src="https://utfs.io/f/dcYEW17H8PtSybKrtfc6A7g0HwfjJB1pUcoaeWNGCOVqmx4d"
          poster="/hero-video-poster.png"
          loop
          autoPlay
          muted
          playsInline
          className="hidden h-auto w-full max-w-[1024px] animate-fade-in-up rounded border border-emerald-500 bg-neutral-50 delay-300 sm:block"
        />
        <video
          src="https://utfs.io/f/dcYEW17H8PtSoKSUjckJNDeCMyPTiWlOqn0BV6uRKgkZ8Grp"
          poster="https://utfs.io/f/dcYEW17H8PtSn6JQ4oKn0oVMSKwLex3IOE8WmC6bvc45kiDF"
          loop
          autoPlay
          muted
          playsInline
          className="h-auto w-full animate-fade-in-up rounded border border-emerald-500 bg-neutral-50 delay-300 sm:hidden"
        />

        <div className="absolute bottom-0 h-16 w-full bg-[linear-gradient(180deg,rgba(236,253,245,0)_0%,#ECFDF5_49.4%)]" />
      </div>
    </section>
  );
}
